module.exports = __webpack_public_path__ + "static/out.35336f66.svg";